<template>
	<div class="overflow-remove contact-page-bg">
		<div class="text-left contact-information-stepper w-100">
			<div class="assessmentSection">
				<div class="row">
					<div class="col-3"></div>
					<div class="col-6">
						<div class="assessmentdiv">
							<h4>Assessment Import</h4>
							<div class="assessmentdivbody">
								<b-form class="contact-form-step1">
									<label class="color-dark-grey">Enter the UID: <span class="red">*</span></label> 
									<b-form-group>
										<b-form-input
										v-model="form.enterPID"
										type="text"
										placeholder="Enter ..."
										autocomplete="off"
										:disabled="inputdisablestatus"
										/>
									</b-form-group>
									<div class="DownloadImportTemplate">
										<div v-if="ImportBtn">
											<span class="ImportProspectInput btn btn-primary btn-file">
												Import File <input type="file" id="file2" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" :disabled="disabledStatus"
												@change="onChangeAssessmentFileImport" :key="fileInputKey" required>
											</span>
											<xlsx-read :file="file">
											<xlsx-json>
												<template #default="{collection}">
												<div>{{ AssessmentImportDataCollection(collection) }}</div>
												</template>
											</xlsx-json>
											</xlsx-read>
										</div>
										<div class="DownloadImportTemplate">
											<div v-if="SubmitImportLoader" class="loader-blue submitimportbtnloader"><div class="loader4"></div></div>
											<b-button v-if="SubmitImportBtn" type="submit" variant="outline-primary" @click.stop.prevent="fetchProspectsButton()">Submit</b-button>
											<b-button v-if="finalImportProcessBtn" type="submit" variant="outline-primary" @click.stop.prevent="finalImportProcess()">Next</b-button>
										</div>
										<b-button v-if="clearProspectImportbtn" variant="outline-primary" @click.stop.prevent="clearProspectImport()">Clear</b-button>
									</div>
								</b-form> 
								<div v-if="foundExistingProsDiv" style="text-align:center;">Found {{this.foundExistingPros}} Prospects</div>
								<div v-if="updatedCCIDiv" style="text-align:center;">{{this.updatedCCI}} Prospects Updated</div>
							</div>
						</div>
					</div>
					<div class="col-3"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapState } from 'vuex'
	import axios from "axios";
	import { XlsxRead, XlsxJson } from "vue-xlsx/dist/vue-xlsx.es.js"
	export default {
		name: "AssessmentImport",
		components: {
			XlsxRead,
			XlsxJson
		},
		computed: {
            ...mapState('firebase', ['prospects'])
        },
		methods: {
			// INITIALIZE
			ResetInitVal() {
				this.importcollection=[];
				this.disabledStatus = false;
				this.keyHeader = [];
				this.valueHeader = [];
				this.storeprospectsNumber = [];
				this.existingProspects = [];
				this.newProspects = [];
				this.userDocData = [];
				this.snapArray = [];
				this.sortedResultArray = [];
				this.updatedCCIDiv=false;
				this.userDocId='';
				this.finalImportProcessBtn=false;
				this.foundExistingPros=0;
				this.foundExistingProsDiv=false;
				this.inputdisablestatus=false;
			},
			// CLEAR
			clearProspectImport() {
				this.ResetInitVal();
				this.SubmitImportLoader = false;
				this.SubmitImportBtn = true;
				this.ImportBtn=false;
				this.clearProspectImportbtn=false;
				this.form.enterPID = '';
				this.updatedCCI=0;
			},
			// ON CLICK UID CHECK PROSPECTS
			fetchProspectsButton() {
				this.ResetInitVal();
				var enterPID = this.form.enterPID;
				if(enterPID && enterPID.length > 22) {
					this.SubmitImportLoader = true;
					this.SubmitImportBtn = false;
					this.getUserDetails(enterPID);
				} else {
					alert('Please enter the correct UID and process.');
					this.form.enterPID = '';
				}
			},
			// API: GET CURRENT USER DETAILS
			getUserDetails(enterPID) {
				const searchUser = {
					searchBy:'Uid',
					searchValue:enterPID,
				};
				axios.post("https://us-central1-tatext-thirdpool.cloudfunctions.net/tatext/getUser", searchUser)
				.then(response => {
					this.userDocData = response.data[0];
					this.userDocId = response.data[0].id;
					this.GetProspectsAccordingToUID();
					//eslint-disable-next-line
					console.log('this.userDocData', this.userDocData);
					//eslint-disable-next-line
					console.log('this.userDocId', this.userDocId);
				}).catch(err => alert(`Failure getting user match: ${err}`));
			},
			// API: GET ALL PROSPECTS ACCORDING UID
			async GetProspectsAccordingToUID() {
				const searchUser = {
					pid: this.userDocId,
				};
				await axios.post("https://us-central1-tatext-thirdpool.cloudfunctions.net/tatext/getProspectListByDocID", searchUser)
				.then(response => {
					this.UIDprospects = response.data;
					//eslint-disable-next-line
					console.log('response: ',response);
					//eslint-disable-next-line
					console.log('UIDprospects: ',this.UIDprospects);
					this.SubmitImportLoader = false;
					this.SubmitImportBtn = false;
					this.ImportBtn = true;
					this.clearProspectImportbtn=true;
					this.inputdisablestatus=true;
				}).catch(err => alert(`Failure getting existing prospect match: ${err}`));
			},
			// ON CHANGE ASSESSMENT IMPORT
			onChangeAssessmentFileImport(event) {
				var fileName = document.querySelector('#file2').value;
				var extension = fileName.split('.').pop();
				if(extension == 'csv' || extension == 'xlsx' || extension == 'xls') {
					if(this.form.enterPID && this.form.enterPID.length > 22) {
						this.file = event.target.files ? event.target.files[0] : null;
						setTimeout(() => {
							this.AssessmentImportDataValidation();
						}, 100);
					} else {
						alert('Please enter the correct UID and process.');
						this.form.enterPID = '';
					}
				} else {
					this.fileInputKey++;
					alert('Import file must be in a .csv, .xls, or .xlsx format');
				}
			},
			AssessmentImportDataCollection(collection) {
				this.importcollection = collection;
			},
			// CHECK NUMBER VALIDATION
			checkPhoneNumberValidation() {
				if(this.keyHeader.includes('Phone Number')) {
					let idexno = this.keyHeader.indexOf('Phone Number');
					var numberget = ''+this.valueHeader[idexno]+'';
					var numberr;
				
					var numberone = numberget;
					var numbertwo = numberone.replace(/[^0-9]/g, "");
					if(numbertwo.length == 11) {
						numberr = '+1'+numberget.substring(1);
					} else {
						numberr = '+1'+numbertwo;
					}
					this.valueHeader[idexno] = numberr;
				}
			},
			// RENAME KEY NAME
			renameProperty(obj, oldName, newName) {
				obj[newName] = obj[oldName];
				delete obj[oldName];
			},
			// CALCULATE PRIORITY LOGIC
			calculatePriorityLogic(data) {
				let val = 0;
				let pf,pfid;
				if (this.userDocData.hasOwnProperty('CciProfiles') && this.userDocData.CciProfiles) {
					let defaultProfile =  this.userDocData.CciProfiles.find(cp => cp.Default == true);
					if (defaultProfile) {
						if (
							(data.Builder >= defaultProfile.BuilderLower && data.Builder <= defaultProfile.BuilderUpper) &&
							(data.Merchant >= defaultProfile.MerchantLower && data.Merchant <= defaultProfile.MerchantUpper) && 
							(data.Innovator >= defaultProfile.InnovatorLower && data.Innovator <= defaultProfile.InnovatorUpper) && 
							(data.Banker >= defaultProfile.BankerLower && data.Banker <= defaultProfile.BankerUpper) &&
							(data.Intuitive >= defaultProfile.IntuitiveLower && data.Intuitive <= defaultProfile.IntuitiveUpper) &&
							(data.Cognitive >= defaultProfile.CognitiveLower && data.Cognitive <= defaultProfile.CognitiveUpper) && 
							(data.Practical >= defaultProfile.PracticalLower && data.Practical <= defaultProfile.PracticalUpper) &&
							(data.Creative >= defaultProfile.CreativeLower && data.Creative <= defaultProfile.CreativeUpper) &&
							(data.Independent >= defaultProfile.IndependentLower && data.Independent <= defaultProfile.IndependentUpper) && 
							(data.Community >= defaultProfile.CommunityLower && data.Community <= defaultProfile.CommunityUpper) 
						) {
							val = 1;
						} else if (
							((data.Builder >= defaultProfile.BuilderLower && data.Builder <= defaultProfile.BuilderUpper) &&
							(data.Merchant >= defaultProfile.MerchantLower && data.Merchant <= defaultProfile.MerchantUpper) && 
							(data.Innovator >= defaultProfile.InnovatorLower && data.Innovator <= defaultProfile.InnovatorUpper) && 
							(data.Banker >= defaultProfile.BankerLower && data.Banker <= defaultProfile.BankerUpper) )||
							((data.Intuitive >= defaultProfile.IntuitiveLower && data.Intuitive <= defaultProfile.IntuitiveUpper) &&
							(data.Cognitive >= defaultProfile.CognitiveLower && data.Cognitive <= defaultProfile.CognitiveUpper) && 
							(data.Practical >= defaultProfile.PracticalLower && data.Practical <= defaultProfile.PracticalUpper) &&
							(data.Creative >= defaultProfile.CreativeLower && data.Creative <= defaultProfile.CreativeUpper) &&
							(data.Independent >= defaultProfile.IndependentLower && data.Independent <= defaultProfile.IndependentUpper) && 
							(data.Community >= defaultProfile.CommunityLower && data.Community <= defaultProfile.CommunityUpper))
						) {
							val = 2;
						}else if (
							((data.Builder <= defaultProfile.BuilderLower || data.Builder >= defaultProfile.BuilderUpper) ||
							(data.Merchant <= defaultProfile.MerchantLower || data.Merchant >= defaultProfile.MerchantUpper) ||
							(data.Innovator <= defaultProfile.InnovatorLower || data.Innovator >= defaultProfile.InnovatorUpper) || 
							(data.Banker <= defaultProfile.BankerLower || data.Banker >= defaultProfile.BankerUpper) ) &&
							((data.Intuitive <= defaultProfile.IntuitiveLower || data.Intuitive >= defaultProfile.IntuitiveUpper) ||
							(data.Cognitive <= defaultProfile.CognitiveLower || data.Cognitive >= defaultProfile.CognitiveUpper) ||
							(data.Practical <= defaultProfile.PracticalLower || data.Practical >= defaultProfile.PracticalUpper) ||
							(data.Creative <= defaultProfile.CreativeLower || data.Creative >= defaultProfile.CreativeUpper) ||
							(data.Independent <= defaultProfile.IndependentLower || data.Independent >= defaultProfile.IndependentUpper) || 
							(data.Community <= defaultProfile.CommunityLower || data.Community <= defaultProfile.CommunityUpper))
						) {
							val = 3;
						}
						pf = defaultProfile.Name;
						pfid = defaultProfile.ProfileId;
					}else {
						val = 0;
						pf = '';
						pfid = ''
					}
				}
				return { val, pf, pfid };
			},
			// RECORD CCIMAP
			recordCCIMap(FilterByGetData2) {
				let ff = {
					pid:this.userDocId,
					cid:FilterByGetData2.id,
					cciMap:{
						DateSubmitted:Date.now(),
						Builder:FilterByGetData2.Builder,
						Merchant:FilterByGetData2.Merchant,
						Innovator:FilterByGetData2.Innovator,
						Banker:FilterByGetData2.Banker,
						Intuitive:FilterByGetData2.Builder+FilterByGetData2.Merchant,
						Cognitive:FilterByGetData2.Innovator+FilterByGetData2.Banker,
						Practical:FilterByGetData2.Builder+FilterByGetData2.Banker,
						Creative:FilterByGetData2.Merchant+FilterByGetData2.Innovator,
						Independent:FilterByGetData2.Builder+FilterByGetData2.Innovator,
						Community:FilterByGetData2.Banker+FilterByGetData2.Merchant
					}
				}

				let pdata  = this.calculatePriorityLogic(ff.cciMap);
				ff.cciMap['Priority'] = pdata.val;
				ff.cciMap['ProfileName'] = pdata.pf;
				ff.cciMap['ProfileId'] = pdata.pfid;

				this.calculateSnapshot(FilterByGetData2);

				ff.cciMap['SnapshotName'] = this.sortedResultArray[0].key+'/'+this.sortedResultArray[1].key;

				//eslint-disable-next-line
				//console.log('ff', ff.cciMap);

				this.recordCCIMapUpdate(ff);

			},
			// API: UPDATE CCIMAP
			async recordCCIMapUpdate(ff)
			{
				await axios.post("https://us-central1-tatext-thirdpool.cloudfunctions.net/tatext/updateProspCciMapFromAssessment", ff)
				.then(response => {
					//eslint-disable-next-line
					console.log(response);
					this.updatedCCI = this.updatedCCI + 1;
				}).catch(err => {alert(`Failure in Updating prospect from assessment: ${err}`); return;});
				
				if(this.updatedCCI == this.existingProspects.length) {
					this.SubmitImportLoader = false;
					this.clearProspectImportbtn=true;
				}
			},
			AssessmentImportDataValidation() {
				if(this.importcollection && this.importcollection.length) {
					if(this.UIDprospects && this.UIDprospects.length) {
						
						//eslint-disable-next-line
						console.log('My DB Prospects', this.UIDprospects);
						
						for(var k=0; k<this.importcollection.length; k++) {
							this.keyHeader = Object.keys(this.importcollection[k]);
							this.valueHeader = Object.values(this.importcollection[k]);
							this.checkPhoneNumberValidation();
							this.importcollection[k]['Phone Number'] = this.valueHeader[0];
							this.renameProperty(this.importcollection[k], 'Phone Number', 'Number');
						}
						
						//eslint-disable-next-line
						console.log('Latest Import Collection:', this.importcollection);

						this.importcollection.forEach(element1 => {
							let FilterByGetData = this.UIDprospects.find(ps => ps.Number == element1.Number);
							if(FilterByGetData) {
								element1['id'] = FilterByGetData.id;
								this.existingProspects.push(element1);
							} else {
								this.newProspects.push(element1);
							}
						});
						
						//eslint-disable-next-line
						console.log('this.newProspects', this.newProspects);

						//eslint-disable-next-line
						console.log('this.existingProspects', this.existingProspects);

						this.ImportBtn=false;
						this.foundExistingProsDiv=true;
						this.foundExistingPros = this.existingProspects.length;
						if(this.foundExistingPros>0) {
							this.finalImportProcessBtn=true;
						}

					}
				}
			},
			// FINAL IMPORT PROCESS BTN
			finalImportProcess() {
				this.foundExistingProsDiv=false;
				this.finalImportProcessBtn=false;
				this.updatedCCIDiv = true;
				this.ImportBtn=false;
				this.SubmitImportLoader = true;
				this.clearProspectImportbtn=false;

				this.UIDprospects.forEach(element2 => {
					let FilterByGetData2 = this.existingProspects.find(ps => ps.Number == element2.Number);
					if(FilterByGetData2) {
						this.snapArray = [];
						this.sortedResultArray = [];
						this.recordCCIMap(FilterByGetData2);
					}
				});
			},
			// CALCULATE SNAPSHOT LOGIC
			calculateSnapshot(FilterByGetData2) {
				this.snapArray.push(
					{ key:'Builder', value:FilterByGetData2.Builder },
					{ key:'Merchant', value:FilterByGetData2.Merchant },
					{ key:'Innovator', value:FilterByGetData2.Innovator },
					{ key:'Banker', value:FilterByGetData2.Banker }
				)
				Object.assign(this.sortedResultArray, this.snapArray);
				this.sortedResultArray.sort((a1, a2) => a2.value - a1.value);
			},
		},
		data() {
			return {
				file: null,
				fileInputKey: 0,
				UIDprospects:[],
				form: {
					enterPID: '',
				},
				importcollection:[],
				disabledStatus: false,
				keyHeader:[],
				valueHeader:[],
				SubmitImportLoader:false,
				SubmitImportBtn:true,
				ImportBtn:false,
				clearProspectImportbtn:false,
				storeprospectsNumber:[],
				existingProspects:[],
				newProspects:[],
				userDocData:[],
				updatedCCI:0,
				snapArray:[],
				sortedResultArray:[],
				updatedCCIDiv:false,
				userDocId:'',
				finalImportProcessBtn:false,
				foundExistingPros:0,
				foundExistingProsDiv:false,
				inputdisablestatus:false,
			}
        }
    }
</script>

<style scoped>
.red{
	color:red;
}
.assessmentSection{
	padding: 8% 5%;
}
.DownloadImportTemplate{
	text-align: center;
	margin: 30px;
}
.DownloadImportTemplate .btn-outline-primary{
    padding: 10px 30px;
}
.ImportProspectInput{
	color: #007bff;
    background-color: transparent;
    border-color: #007bff;
	cursor: pointer;
	padding: 10px 30px;
	position: relative;
    overflow: hidden;
}
.ImportProspectInput.btn-primary:hover {
    color: #fff;
    background-color: #007bff;
    border-color: #007bff;
}
.ImportProspectInput input[type=file] {
    position: absolute;
    top: 0;
    right: 0;
    min-width: 100%;
    min-height: 100%;
    font-size: 100px;
    text-align: right;
    filter: alpha(opacity=0);
    opacity: 0;
    outline: none;   
    cursor: inherit;
    display: block;
}
.loader4 {
   width:30px;
   height:30px;
   display:inline-block;
   padding:0px;
   border-radius:100%;
   border:5px solid;
   border-top-color:#fff;
   border-bottom-color:rgba(255,255,255, 0.3);
   border-left-color:#fff;
   border-right-color:rgba(255,255,255, 0.3);
   -webkit-animation: loader4 1s ease-in-out infinite;
   animation: loader4 1s ease-in-out infinite;
}
.loader-blue .loader4{
    border-top-color:#06187c;
   border-bottom-color:rgba(255,255,255, 0.3);
   border-left-color:#06187c;display: flex;
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    top: 0;
    bottom: 0;
   border-right-color:rgba(255,255,255, 0.3);
}
.loader-blue{
    position: absolute;
    padding-left: 0px;
    top: 0;z-index: 9999;
    margin: auto;
    bottom: 0;
}
@keyframes loader4 {
   from {transform: rotate(0deg);}
   to {transform: rotate(360deg);}
}
@-webkit-keyframes loader4 {
   from {-webkit-transform: rotate(0deg);}
   to {-webkit-transform: rotate(360deg);}
}
.submitimportbtnloader{
	position: relative;
    padding: 22px;
    display: inline-block;
    width: 18%;
    color: #007bff;
    border: 1px solid #007bff;
    border-radius: 5px;
}
.assessmentdiv h4{
	padding: 20px;
    font-size: 20px;
    background-color: #e6e6e6;
    text-align: center;
	margin-bottom:0px;
}
.assessmentdiv {
	background: #fff;
    border-radius: 4px;
    box-shadow: 1px 2px 8px 1px #dde;
}
.assessmentdivbody{
    padding: 40px;
}
</style>